import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";

export const Route = createFileRoute("/privacy-policy")({
  head: () => pageHead("Privacy Policy", "AKIVA privacy policy - How we collect, use, and protect your personal information.", "/privacy-policy", false),
  component: PrivacyPolicyPage,
});
